<template>
	<div v-if="link.items">
		<div class="flex">
			<AbsoluteInternalLink
				:to="link.url"
				class="block px-4 py-3 hover:bg-orange-100 [&.router-link-active]:font-bold w-full text-base"
				@click="$emit('click')"
			>
				{{ link.label }}
			</AbsoluteInternalLink>
			<button
				type="button"
				:aria-label="visible ? `Zavřít menu ` : `Otevřít menu ` + link.label"
				class="border-l border-border-tertiary block px-3"
				:aria-expanded="visible"
				@click="toggleVisible()"
			>
				<NuxtIcon
					name="chevron-down"
					class="text-[1.75rem] text-icon-neutral relative block transition-transform"
					:class="{'rotate-180': visible}"
					filled
					aria-hidden="true"
				/>
			</button>
		</div>

		<transition name="fade">
			<ul v-if="visible" class="pl-4">
				<div v-for="(subLink, index) in link.items" :key="index">
					<AbsoluteInternalLink
						:to="subLink.url"
						class="block px-4 py-3 hover:bg-orange-100 [&.router-link-active]:font-bold text-base"
						@click="$emit('click', subLink.label)"
					>
						{{ subLink.label }}
					</AbsoluteInternalLink>
				</div>
			</ul>
		</transition>
	</div>
</template>

<script setup lang="ts">
	import type {MenuLink} from '../../types/header';

	interface Props {
		link: MenuLink
	}

	defineProps<Props>();
	defineEmits<{
		(e: 'click', label?: string): void
	}>();

	const [visible, toggleVisible] = useToggle();
</script>
